import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const EmployeeSchema = withDefaults({
  type: 'employee',
  objectExtensions: ['employee'],
  traits: ['commentable'],
  fields: [
    {
      kind: 'attribute',
      name: 'addressLine1',
    },
    {
      kind: 'attribute',
      name: 'addressLine2',
    },
    {
      kind: 'attribute',
      name: 'birthYear',
    },
    {
      kind: 'attribute',
      name: 'city',
    },
    {
      kind: 'attribute',
      name: 'contributionAmount',
    },
    {
      kind: 'attribute',
      name: 'costCenter',
    },
    {
      kind: 'attribute',
      name: 'country',
    },
    {
      kind: 'attribute',
      name: 'currency',
    },
    {
      kind: 'attribute',
      name: 'customAttributes',
    },
    {
      kind: 'attribute',
      name: 'department',
    },
    {
      kind: 'attribute',
      name: 'eligibilityEndDate',
    },
    {
      kind: 'attribute',
      name: 'eligibilityStartDate',
    },
    {
      kind: 'attribute',
      name: 'email',
    },
    {
      kind: 'attribute',
      name: 'employmentEndDate',
    },
    {
      kind: 'attribute',
      name: 'employmentStartDate',
    },
    {
      kind: 'attribute',
      name: 'employmentType',
    },
    {
      kind: 'attribute',
      name: 'firstName',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'lastName',
    },
    {
      kind: 'attribute',
      name: 'payrollId',
    },
    {
      kind: 'attribute',
      name: 'phoneNumber',
    },
    {
      kind: 'attribute',
      name: 'postalCode',
    },
    {
      kind: 'attribute',
      name: 'ratePeriod',
    },
    {
      kind: 'attribute',
      name: 'participationStatus',
    },
    {
      kind: 'attribute',
      name: 'userCreatedAt',
    },
    {
      kind: 'attribute',
      name: 'userUpdatedAt',
    },
    {
      kind: 'attribute',
      name: 'salary',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'suffix',
    },
    {
      kind: 'attribute',
      name: 'title',
    },
    {
      kind: 'attribute',
      name: 'userRoleId',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'deactivatedOn',
    },
    {
      kind: 'attribute',
      name: 'inviteLink',
    },
    {
      kind: 'attribute',
      name: 'statistics',
    },
    {
      kind: 'attribute',
      name: 'meta',
    },
    {
      kind: 'attribute',
      name: 'syfGraceActive',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'plan',
      type: 'plan',
      options: {
        async: false,
        inverse: 'employees',
      },
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'person',
      type: 'person',
      options: {
        async: false,
        inverse: 'employees',
      },
    },
    {
      kind: 'belongsTo',
      name: 'workspace',
      type: 'workspace',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'pslfProfile',
      type: 'pslf-profile',
      options: {
        async: false,
        inverse: 'employee',
      },
    },
    {
      kind: 'belongsTo',
      name: 'tasParticipant',
      type: 'tas-participant',
      options: {
        async: false,
        inverse: 'employee',
      },
    },
    {
      kind: 'belongsTo',
      name: 'matchParticipant',
      type: 'match-participant',
      options: {
        async: false,
        inverse: 'employee',
      },
    },
    {
      kind: 'belongsTo',
      name: 'employeeAddition',
      type: 'employee-addition',
      options: {
        async: false,
        inverse: 'employee',
      },
    },
    {
      kind: 'hasMany',
      name: 'accounts',
      type: 'account',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'families',
      type: 'family',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'dependents',
      type: 'dependent',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'notificationHistories',
      type: 'notification-history',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'phoneNumbers',
      type: 'phone-number',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'postalAddresses',
      type: 'postal-address',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'pslfAssets',
      type: 'pslf-asset',
      options: {
        async: false,
        inverse: 'employees',
      },
    },
    {
      kind: 'hasMany',
      name: 'pslfForms',
      type: 'pslf-form',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'scholarships',
      type: 'scholarship',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'strategyFinderResults',
      type: 'strategy-finder-result',
      options: {
        async: false,
        inverse: 'employees',
      },
    },
    {
      kind: 'hasMany',
      name: 'versions',
      type: 'employee-version',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'tasProgramInstances',
      type: 'tas-program-instance',
      options: {
        async: false,
        inverse: 'employee',
      },
    },
    {
      kind: 'hasMany',
      name: 'tasApplications',
      type: 'tas-application',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'roleViews',
      type: 'role-view',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'jurisdictiveRelationships',
      type: 'generic-relationship',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'invites',
      type: 'invite',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'tags',
      type: 'tag',
      options: {
        async: false,
        inverse: 'taggable',
        as: 'taggable',
      },
    },
    {
      kind: 'hasMany',
      name: 'tasEligibilities',
      type: 'tas-eligibility',
      options: {
        async: false,
        inverse: 'employee',
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsCardHolders',
      type: 'pcs-card-holder',
      options: {
        async: false,
        inverse: 'employee',
      },
    },
  ],
});

export default EmployeeSchema;
